import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc7fb0f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "backdrop" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", {
  transform: "rotate(-45)",
  class: "falling"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "-20%",
    y: "1%",
    width: "4",
    ry: "2",
    fill: "url(#starGradient)",
    class: "star"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "20%",
    y: "30%",
    width: "4",
    ry: "2",
    fill: "url(#starGradient)",
    class: "star"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "48%",
    y: "50%",
    width: "4",
    ry: "2",
    fill: "url(#starGradient)",
    class: "star"
  })
], -1))
const _hoisted_3 = { class: "still" }
const _hoisted_4 = ["cy", "cx", "rx", "ry"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "starGradient",
    gradientTransform: "rotate(90)"
  }, [
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "5%",
      "stop-color": "white",
      "stop-opacity": "0"
    }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "100%",
      "stop-color": "white",
      "stop-opacity": "1"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", null, [
      _hoisted_2,
      _createElementVNode("g", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stars, (star, index) => {
          return (_openBlock(), _createElementBlock("ellipse", {
            class: "star",
            key: index,
            cy: star.y,
            cx: star.x,
            rx: star.size,
            ry: star.size
          }, null, 8, _hoisted_4))
        }), 128))
      ]),
      _hoisted_5
    ])),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}